import { PageHeader } from "@/components/ui/design-system";
import { Link } from "react-router-dom";

import { useAuth } from "@/context/AuthContext";

/**
 * The home screen for an account that administers the system rather than
 * working in it.
 *
 * O-11 gives `superadmin` no business data at all. Before this screen existed
 * such an account still landed on the personnel dashboard, which immediately
 * asked for the whole register and was refused — so the first thing a
 * technical administrator saw after signing in was a failure, on a screen he
 * was never meant to open.
 *
 * The tone here is deliberate: not having these rights is the design, not a
 * fault and not something to troubleshoot. The screen says what the account
 * *does* hold and how the missing rights are obtained, so nobody concludes
 * the system is broken and starts looking for a workaround.
 */
export function PocetnaAdministrativnaPage() {
  const { user } = useAuth();
  const uloge = user?.roles.map((uloga) => uloga.name_hr).join(", ");

  return (
    <div className="flex flex-col gap-8">
      <PageHeader title={<>Administracija</>} meta={<>{uloge ? <p className="oznaka">{uloge}</p> : null}</>} />

      <section className="avm-surface flex flex-col gap-3 rounded-[var(--radius-card)] border border-[var(--color-border)] bg-[var(--color-card)] p-6">
        <h2 className="text-[var(--text-section)] font-semibold">
          Poslovni podaci traže poslovnu ulogu
        </h2>
        <p className="max-w-[60ch] text-[var(--color-muted-foreground)]">
          Ovaj račun ima tehničke ovlasti: uloge i ovlasti, šifrarnici i
          zapisnik izmjena. Kadrovska evidencija, gradilišta i evidencija rada
          nisu dio tih ovlasti — plaće, IBAN-i, adrese, zdravstveni podaci i
          dozvole drže kadrovska i uprava.
        </p>
        <p className="max-w-[60ch] text-[var(--color-muted-foreground)]">
          Nije riječ o grešci. Ako vam ti podaci stvarno trebaju, uz ovu se
          dodjeljuje i kadrovska uloga — dodjela je vidljiva u matrici ovlasti i
          u zapisniku izmjena.
        </p>
      </section>

      <section className="flex flex-col gap-3">
        <h2 className="text-[var(--text-section)] font-semibold">Vaš račun</h2>
        <ul className="flex flex-col gap-2">
          <li>
            <Link
              to="/postavke/lozinka"
              className="font-medium underline underline-offset-2"
            >
              Promjena lozinke
            </Link>
          </li>
          <li>
            <Link
              to="/postavke/dvofaktorska"
              className="font-medium underline underline-offset-2"
            >
              Dvofaktorska prijava
            </Link>
          </li>
        </ul>
      </section>
    </div>
  );
}
